import React from 'react'
import Header from '../component/Header'
import Intro from '../component/Intro'
import Keyfeature from '../component/Keyfeature';
import Testimonial from '../component/Testimonial';
import Achivment from '../component/Achivment';
import HeroBanner from '../component/HeroBanner';
import HomeService from '../component/HomeService';
import Process from '../component/Process';
import CallAction from '../component/CallAction'
import Footer from '../component/Footer';
import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";



export default function Home() {
      const cards = [
        {
            id: 1,
            title: "Fill The Form",
            desc: "Submit your mobile number and basic details to begin.",
            image:
                "https://images.unsplash.com/photo-1556740749-887f6717d7e4?w=1000",
            color: "from-cyan-500 to-blue-500",
        },
        {
            id: 2,
            title: "Review Application",
            desc: "We verify your eligibility and documents instantly.",
            image:
                "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=1000",
            color: "from-orange-500 to-pink-500",
        },
        {
            id: 3,
            title: "Get Money",
            desc: "Loan amount gets transferred directly to your account.",
            image:
                "https://images.unsplash.com/photo-1579621970795-87facc2f976?w=1000",
            color: "from-emerald-500 to-green-500",
        },
    ];
    return (
        <>
            <Header />
            <HeroBanner />
            <HomeService />
            <Intro />
            <Keyfeature />
            <Achivment />
            {/* <Testimonial /> */}
            <Process/>
            <CallAction/>
            
            <Footer />

        </>
    )
}
